import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  Button,
  DatePicker,
  Radio,
  Checkbox,
  Cascader,
  Typography,
  Col,
  Row,
  Tooltip,
  Select,
  Table,
  Collapse,
  BackTop,
  Menu,
  Dropdown,
} from 'antd';
import Icon, {
  InfoCircleFilled,
  LoadingOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import styles from '../../../../shared-components/Recipe/recipe.module.sass';
import { default as threat_detail_styles } from '../../../HomeContainer/components/Home/threat-detail.module.sass';
import moment from 'moment-timezone';
import store from '../../../../redux/store';
import mixpanel from 'mixpanel-browser';
import history from '../../../../redux/history';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { STATUS } from '../../../../redux/constants';
import { changeTitle } from '../../../../redux/actions/app';
import { useDispatch, useSelector } from 'react-redux';
import SavedRecipeModal from '../../../../shared-components/SavedRecipeModal';
import useModalNameValidator from '../../../../redux/utils/useModalNameValidator';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import { highlightLeftMenu } from '../../../../redux/actions/leftMenu';
import { Link } from 'react-router-dom';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import { allowedSubdomainLookup } from '../../../../shared-components/Validation/Subdomain';
import { ReactComponent as no_results } from '../../../../assets/icons/no_results.svg';
import { ReactComponent as no_results_filled } from '../../../../assets/icons/no_results_filled.svg';
import cx from 'classnames';
import _ from 'lodash';
import HostingInfrastructureIPsResult from '../HostingInrastructureIPsRecipe/ResultsTable';
import { validateRecipeDomainName } from '../../../../shared-components/Validation/RecipeDomainName';
import DeleteRecipeModal from '../../../../shared-components/DeleteRecipeModal';
import { JSONViewer } from '../../../../shared-components/JSONViewer';
import { BackToTopButton } from '../../../../shared-components/BackToTopButton';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';
const { Panel } = Collapse;

function HostingInfrastructureIPsQuery(props) {
  mixpanel.track('Global Nav - Hositng Infrastructure IPs', {
    location: window.location.href,
  });
  const {
    exploreRecipeHostingInfraIPs,

    exploreRecipeSpoofing,
    loadMergeAPIRiskScores,
    loadMergeAPIASNDetails,
    loadUser,
    loadSources,
    createEmptySource,
    createFileSource,
    updateFileSource,
    addIOCJson,
    clearExploreDetails,
    loadScoreDetails,
    loadMergeAPIExploreRecipe,
    loadMergeAPIEnrichment,
    loadMergeAPIIPDetails,
    loadMergeAPIDomainDetails,
    loadMergeAPIExploreDetails,
    loadMergeAPIMergeDetails,
    loadMergeAPIExploreAnyIPDetails,
    loadMergeAPIExploreDensity,
    loadMergeAPIWhoisDetails,
    loadMergeAPIDomainInfraTags,
    loadIPEditableFeeds,
    loadDomainEditableFeeds,
    loadURLEditableFeeds,
    searchForTags,
    resetTagSearch,
    saveMonitoringQuery,
    loadResultFile,
    loadHistoryQueryResult,
    exportExploreResultToCSV,
    exportExploreResultToJSON,
    exportDanglingDNSToCSV,
    exportDanglingDNSToJSON,
    exportSingleIOC,
    resetEnrichment,
    loadMySubscriptionPlan,
    saveBreadCrumbs,
    queryNameInTXTRecipe,

    user,
    sources,
    exploreFilters,
    exploreSorting,
    status,
    scoreDetails,
    mergeAPIEnrichment,
    mergeAPIscoreDetails,
    exploreAPIscoreDetails: exploreAPIscoreDetails,
    mergeAPIData: mergeAPIData,
    exploreAPIANYIPscoreDetails: exploreAPIANYIPscoreDetails,
    exploreAPIANYIPJobID: exploreAPIANYIPJobID,
    exploreAPIDensityDetails: exploreAPIDensityDetails,
    exploreAPIDensityStatus: exploreAPIDensityStatus,
    exploreAPIwhoisDetails: exploreAPIwhoisDetails,
    infraTagStatus: infraTagStatus,
    domainInfraTags: domainInfraTags,
    whoisStatus: whoisStatus,
    IPEditableFeeds: IPEditableFeeds,
    IPEditableFeedsStatus: IPEditableFeedsStatus,
    DomainEditableFeeds: DomainEditableFeeds,
    DomainEditableFeedsStatus: DomainEditableFeedsStatus,
    URLEditableFeeds: URLEditableFeeds,
    URLEditableFeedsStatus: URLEditableFeedsStatus,
    foundTags: foundTags,
    searchStatus: searchStatus,
    riskScoreStatus: riskScoreStatus,
    exploreRiskScores: exploreRiskScores,
    exploreASNStatus: exploreASNStatus,
    exploreASNDetails: exploreASNDetails,
    mySubscriptionPlan: mySubscriptionPlan,
    mySubscriptionPlanStatus: mySubscriptionPlanStatus,
    breadcrumbs: breadcrumbs,
    loadBrandImpersonationRecipeResults,
    loadDanglingDNSDetectionRecipeResults,
    loadHostingInfrastructureIPsRecipeResults,
    clearRecipe,
    unsetClearRecipe,
    deleteMergeAPIExploreRecipeDanglingDNSProtection,
  } = props;
  const { Text, Title, Paragraph } = Typography;

  function useQuery() {
    return new URLSearchParams(window.location.search);
  }

  const q = useQuery();

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [nameOfNewQuery, setNameOfNewQuery] = useState('');
  const [descriptionOfNewQuery, setDescriptionOfNewQuery] = useState('');
  const [saveModalType, setSaveModalType] = useState('saveNew');
  const [is24hrCheckboxSet, setIs24hrCheckboxSet] = useState(false);
  const [formValues, setFormValues] = useState({});
  const isSaveModalValid = useModalNameValidator(nameOfNewQuery);
  const titleText = q?.get('left_menu_name') || 'Hosting Infrastructure IPs';
  const is24hrCheckboxSetCurrentValue = Form.useWatch('is_last_24_hours', form);
  const threatNameValue = Form.useWatch('threat_name', form);
  const sortFormValue = Form.useWatch('sort', form);
  const [searchQuery, setSearchQuery] = useState('');
  const ClearFilters = (props) => <Icon component={no_results} {...props} />;
  const ClearFiltersFilled = (props) => (
    <Icon component={no_results_filled} {...props} />
  );
  const NoDataIcon = (props) => <Icon component={no_results} {...props} />;

  const [activeCollapseKey, setActiveCollapseKey] = useState(['1']);

  const openAllCollapse = () => {
    setActiveCollapseKey(['1', '2']);
  };

  const toggleCollapse = (key) => {
    if (activeCollapseKey?.includes(key)) {
      setActiveCollapseKey(activeCollapseKey?.filter((k) => k !== key));
    } else {
      setActiveCollapseKey([...activeCollapseKey, key]);
    }
  };

  const recipeInitCollapse = () => {
    setActiveCollapseKey(['1']);
  };

  const searchActionCollapse = () => {
    setActiveCollapseKey(['2']);
  };

  const options = [
    {
      value: 'first_seen',
      label: 'First Seen',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
    {
      value: 'last_seen',
      label: 'Last Seen',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
    {
      value: 'query',
      label: 'Query',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
    {
      value: 'answer',
      label: 'Answer',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
  ];

  useEffect(() => {
    document.title = `${titleText} - Silent Push`;
    props.clearExploreDetails();
    props.saveBreadCrumbs(null);
    props.loadUser();
    props.loadMySubscriptionPlan();
    props.resetRecipeStatus();
    props.clearExploreDetails();
    form.resetFields();
    recipeInitCollapse();
    setSearchQuery('');
    if (q?.get('recipeid')) {
      //load specific recipe
      props.loadMergeAPIExploreRecipeHostingInfraIPs(q?.get('recipeid'));
    }
    dispatch(changeTitle(titleText, null));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    props.resetRecipeStatus();
    form.resetFields();
    recipeInitCollapse();
    setSaveModalType('saveNew');
    setSearchQuery('');
    if (q?.get('recipeid')) {
      //load specific recipe
      props.loadMergeAPIExploreRecipeHostingInfraIPs(q?.get('recipeid'));
    }
  }, [window.location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (clearRecipe === true) {
      document.title = `${titleText} - Silent Push`;
      props.clearExploreDetails();
      props.saveBreadCrumbs(null);
      props.loadUser();
      props.loadMySubscriptionPlan();
      props.resetRecipeStatus();
      props.clearExploreDetails();
      form.resetFields();
      recipeInitCollapse();
      setSearchQuery('');
      props.unsetClearRecipe();
    }
  }, [clearRecipe]); // eslint-disable-line react-hooks/exhaustive-deps

  function resetForm() {
    form.resetFields();
    props.resetRecipeStatus();
    recipeInitCollapse();
    props.clearExploreDetails();
    props.saveBreadCrumbs(null);
    setSearchQuery('');
    if (q?.get('recipeid')) {
      props.loadMergeAPIExploreRecipeHostingInfraIPs(q?.get('recipeid'));
    }
  }

  function FormHeader() {
    return (
      <div
        // style={{ marginBottom: '-7px' }}
        //className={cx(styles.header, styles.only_text_header)}
        onClick={() => toggleCollapse('1')}
      >
        <Title
          level={4}
          style={{
            textAlign: 'left',
            color: 'white',
            lineHeight: '2',
            margin: '0',
          }}
          // className={styles.title}
        >
          Query Form
        </Title>
      </div>
    );
  }

  function ResultsHeader() {
    return (
      <div
        // style={{ marginBottom: '-7px' }}
        //className={cx(styles.header, styles.only_text_header)}
        onClick={() => toggleCollapse('2')}
      >
        <Title
          level={4}
          style={{
            textAlign: 'left',
            color: 'white',
            lineHeight: '2',
            margin: '0',
          }}
          // className={styles.title}
        >
          Query Results
        </Title>
      </div>
    );
  }

  useEffect(() => {
    // form.resetFields();
    dispatch(
      changeTitle(props?.exploreRecipeHostingInfraIPs?.name ?? titleText, null),
    );
    document.title = `${titleText} - Silent Push`;
    if (
      props.recipeStatusHostingInfraIPs == STATUS.LOADED &&
      props?.exploreRecipeHostingInfraIPs?.name
    ) {
      document.title = `${props?.exploreRecipeHostingInfraIPs?.name} - Silent Push`;
    }

    if (window.location.href.includes('/explore/hosting-infra-ips')) {
      if (
        props?.exploreRecipeHostingInfraIPs?.uuid &&
        window.location.href.indexOf(
          '/explore/hosting-infra-ips?recipeid=' +
            props?.exploreRecipeHostingInfraIPs?.uuid,
        ) == -1
      ) {
        history.push(
          '/explore/hosting-infra-ips?recipeid=' +
            props?.exploreRecipeHostingInfraIPs?.uuid,
        );
        dispatch(highlightLeftMenu(props?.exploreRecipeHostingInfraIPs?.uuid));
      }
      form.resetFields();
      form.setFieldsValue({
        threat_name: exploreRecipeHostingInfraIPs?.domain,
        type: exploreRecipeHostingInfraIPs?.query_type,
        first_seen_before: exploreRecipeHostingInfraIPs?.first_seen_before
          ? moment(exploreRecipeHostingInfraIPs?.first_seen_before)
          : '',
        first_seen_after: exploreRecipeHostingInfraIPs?.first_seen_after
          ? moment(exploreRecipeHostingInfraIPs?.first_seen_after)
          : '',
        last_seen_before: exploreRecipeHostingInfraIPs?.last_seen_before
          ? moment(exploreRecipeHostingInfraIPs?.last_seen_before)
          : '',
        last_seen_after: exploreRecipeHostingInfraIPs?.last_seen_after
          ? moment(exploreRecipeHostingInfraIPs?.last_seen_after)
          : '',
        limit:
          exploreRecipeHostingInfraIPs?.limit === 100
            ? ''
            : exploreRecipeHostingInfraIPs?.limit,
        sort: exploreRecipeHostingInfraIPs?.sort_by
          ? [
              exploreRecipeHostingInfraIPs?.sort_by,
              exploreRecipeHostingInfraIPs?.order_by,
            ]
          : null,
        subdomains: exploreRecipeHostingInfraIPs?.include_subdomains
          ? 'true'
          : 'false',
        is_last_24_hours: exploreRecipeHostingInfraIPs?.is_last_24_hours
          ? exploreRecipeHostingInfraIPs?.is_last_24_hours
          : false,
      });
    }
  }, [props.exploreRecipeHostingInfraIPs]);

  function changeScopeRecipe() {
    props.changeScopeMergeAPIExploreRecipeHostingInfraIPs({
      scope:
        props?.exploreRecipeHostingInfraIPs?.scope === 'USER'
          ? 'ORGANISATION'
          : 'USER',
      uuid: props?.exploreRecipeHostingInfraIPs?.uuid,
    });
    incrementUIRequestsCounter();
  }

  const handleCancel = () => {
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  function returnUiRecipeData(values, type) {
    if (type === 'saveAs') {
      return {
        new_name: nameOfNewQuery
          ? nameOfNewQuery
          : exploreRecipeHostingInfraIPs?.name,
        new_description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : exploreRecipeHostingInfraIPs?.description,
      };
    } else {
      return {
        name: nameOfNewQuery
          ? nameOfNewQuery
          : exploreRecipeHostingInfraIPs?.name,
        description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : exploreRecipeHostingInfraIPs?.description,
        domain: values?.threat_name,
        query_type: values?.type ? values?.type : 'A',
        include_subdomains: values?.subdomains === 'true',
        first_seen_after: values?.first_seen_after
          ? moment(values.first_seen_after)
              .utc({ keepLocalTime: false })
              .set('hour', 0)
              .set('minute', 0)
              .set('second', 0)
              .set('millisecond', 0)
              .format('YYYY-MM-DD')
          : null,
        first_seen_before: values?.first_seen_before
          ? moment(values.first_seen_before)
              .utc({ keepLocalTime: false })
              .set('hour', 0)
              .set('minute', 0)
              .set('second', 0)
              .set('millisecond', 0)
              .format('YYYY-MM-DD')
          : null,
        last_seen_after: values?.last_seen_after
          ? moment(values.last_seen_after)
              .utc({ keepLocalTime: false })
              .set('hour', 0)
              .set('minute', 0)
              .set('second', 0)
              .set('millisecond', 0)
              .format('YYYY-MM-DD')
          : null,
        last_seen_before: values?.last_seen_before
          ? moment(values.last_seen_before)
              .utc({ keepLocalTime: false })
              .set('hour', 0)
              .set('minute', 0)
              .set('second', 0)
              .set('millisecond', 0)
              .format('YYYY-MM-DD')
          : null,
        limit: values?.limit ? values?.limit : 100,
        order_by: values?.sort?.length > 0 ? values?.sort[1] : null,
        sort_by: values?.sort?.length > 0 ? values?.sort[0] : null,
        first_seen_relative: null,
        last_seen_relative: null,
        is_last_24_hours: values?.is_last_24_hours ? true : false,
        uuid: q?.get('recipeid'),
      };
    }
  }

  function updateButtonDisabled() {
    const queryType = form.getFieldValue('type');
    const subdomains = form.getFieldValue('subdomains');
    const firstSeenAfter = form.getFieldValue('first_seen_after')
      ? form.getFieldValue('first_seen_after')
      : null;
    const firstSeenBefore = form.getFieldValue('first_seen_before')
      ? form.getFieldValue('first_seen_before')
      : null;
    const lastSeenAfter = form.getFieldValue('last_seen_after')
      ? form.getFieldValue('last_seen_after')
      : null;
    const lastSeenBefore = form.getFieldValue('last_seen_before')
      ? form.getFieldValue('last_seen_before')
      : null;
    // const sortBy = form.getFieldValue('sort');
    const isLast24Hours = form.getFieldValue('is_last_24_hours');

    if (
      exploreRecipeHostingInfraIPs?.domain !== threatNameValue ||
      exploreRecipeHostingInfraIPs?.query_type !== queryType ||
      exploreRecipeHostingInfraIPs?.include_subdomains?.toString() !==
        subdomains ||
      exploreRecipeHostingInfraIPs?.first_seen_after !== firstSeenAfter ||
      exploreRecipeHostingInfraIPs?.first_seen_before !== firstSeenBefore ||
      exploreRecipeHostingInfraIPs?.last_seen_after !== lastSeenAfter ||
      exploreRecipeHostingInfraIPs?.last_seen_before !== lastSeenBefore ||
      exploreRecipeHostingInfraIPs?.sort_by != sortFormValue?.[0] ||
      exploreRecipeHostingInfraIPs?.order_by != sortFormValue?.[1] ||
      exploreRecipeHostingInfraIPs?.is_last_24_hours !== isLast24Hours
    ) {
      return false;
    } else {
      if (threatNameValue === undefined) {
        return false;
      }
      return true;
    }
  }

  const handleOk = (type) => {
    form
      .validateFields()
      .then((values) => {
        if (saveModalType === 'edit' || type === 'edit') {
          props.updateMergeAPIExploreRecipeHostingInfraIPs(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveNew' || type === 'saveNew') {
          props.saveMergeAPIExploreRecipeHostingInfraIPs(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveAs' || type === 'saveAs') {
          props.cloneRecipe(
            returnUiRecipeData(values, type),
            'hosting-infra-ips-recipes',
            q?.get('recipeid'),
          );
        }
        incrementUIRequestsCounter();
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  const handleDeleteRecipe = () => {
    props.deleteMergeAPIexploreRecipeHostingInfraIPs(q?.get('recipeid'));
    props.resetRecipeStatus();
    props.clearExploreDetails();
    props.history.push(
      '/explore/hosting-infra-ips/?left_menu_name=Hosting Infrastructure - IPs',
    );
    setIsDeleteModalVisible(false);
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
  };

  const DropdownMenu = () => {
    return (
      <Menu>
        {
          <>
            {((q?.get('recipeid') &&
              props?.exploreRecipeHostingInfraIPs?.scope === 'USER') ||
              (q?.get('recipeid') &&
                props?.exploreRecipeHostingInfraIPs?.scope === 'ORGANISATION' &&
                props?.exploreRecipeHostingInfraIPs?.is_mine === true)) && (
              <Menu.Item
                onClick={() => {
                  setSaveModalType('edit');
                  setIsModalVisible(true);
                }}
              >
                Edit Metadata
              </Menu.Item>
            )}

            {((q?.get('recipeid') &&
              props?.exploreRecipeHostingInfraIPs?.scope === 'USER') ||
              (q?.get('recipeid') &&
                props?.exploreRecipeHostingInfraIPs?.scope ===
                  'ORGANISATION')) && (
              <Menu.Item
                onClick={() => {
                  setSaveModalType('saveAs');
                  setIsModalVisible(true);
                }}
              >
                Save As
              </Menu.Item>
            )}

            <Tooltip
              title={
                props.mySubscriptionPlan?.has_access_to_share_unshare ? (
                  ''
                ) : (
                  <>
                    Sharing option is not part of this subscription plan. To
                    upgrade your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                )
              }
            >
              {((q?.get('recipeid') &&
                props?.exploreRecipeHostingInfraIPs?.scope === 'USER') ||
                (q?.get('recipeid') &&
                  props?.exploreRecipeHostingInfraIPs?.scope ===
                    'ORGANISATION' &&
                  props?.exploreRecipeHostingInfraIPs?.is_mine === true)) && (
                <Menu.Item onClick={() => changeScopeRecipe()}>
                  {props?.exploreRecipeHostingInfraIPs?.scope === 'ORGANISATION'
                    ? 'Unshare'
                    : 'Share'}
                </Menu.Item>
              )}
            </Tooltip>

            {((q?.get('recipeid') &&
              props?.exploreRecipeHostingInfraIPs?.scope === 'USER') ||
              (q?.get('recipeid') &&
                props?.exploreRecipeHostingInfraIPs?.scope === 'ORGANISATION' &&
                props?.exploreRecipeHostingInfraIPs?.is_mine === true)) && (
              <Menu.Item onClick={() => setIsDeleteModalVisible(true)}>
                <span style={{ color: 'red' }}>Delete</span>
              </Menu.Item>
            )}
          </>
        }
      </Menu>
    );
  };

  function renderPane() {
    return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
      props.mySubscriptionPlan?.has_access_to_hosting_infra_ips_recipe ? (
        props.recipeStatusHostingInfraIPs !== STATUS.LOADING ? (
          <div className={styles.explore_recipe}>
            <Row gutter={24}>
              <Col xs={24} className={styles.header}>
                <div
                  data-cy="hostingInfrastructureIPsRecipeQueryFormChip"
                  className={cx(threat_detail_styles['type-chip'])}
                >
                  {titleText}
                </div>

                <div className={styles.recipeDescription}>
                  <Paragraph
                    data-cy="hostingInfrastructureIPsRecipeQueryFormDescription"
                    className="m-0"
                  >
                    {exploreRecipeHostingInfraIPs?.description
                      ? exploreRecipeHostingInfraIPs.description
                      : 'Find IPs associated with a specific domain name.'}{' '}
                    <span className={styles.header_former_recipe_appendix_text}>
                      (former Forward A recipe)
                    </span>
                  </Paragraph>

                  <Link
                    to={{
                      pathname:
                        'https://help.silentpush.com/docs/scan-for-ip-associated-with-a-domain-and-subdomains',
                    }}
                    target="_blank"
                  >
                    Knowledge Base
                  </Link>
                </div>

                <div className={styles.action_buttons}>
                  <Tooltip
                    title={
                      updateButtonDisabled() ? 'Form values unchanged.' : ''
                    }
                  >
                    <Button
                      disabled={updateButtonDisabled()}
                      role={'button1'}
                      onClick={() => {
                        if (
                          saveModalType === 'saveNew' &&
                          !q?.get('recipeid')
                        ) {
                          form
                            .validateFields()
                            .then((values) => {
                              setNameOfNewQuery('');
                              setDescriptionOfNewQuery('');
                              setSaveModalType('saveNew');
                              setIsModalVisible(true);
                            })
                            .catch((errorInfo) => {});
                        } else {
                          handleOk('edit');
                        }
                      }}
                    >
                      {q?.get('recipeid') ? 'Update' : 'Save'}
                    </Button>
                  </Tooltip>

                  {((q?.get('recipeid') &&
                    props?.exploreRecipeHostingInfraIPs?.scope === 'USER') ||
                    (q?.get('recipeid') &&
                      props?.exploreRecipeHostingInfraIPs?.scope ===
                        'ORGANISATION')) && (
                    <Dropdown trigger={['click']} overlay={DropdownMenu({})}>
                      <MoreOutlined className={styles.dropdown_icon} />
                    </Dropdown>
                  )}
                </div>
              </Col>
            </Row>

            <BackToTopButton />

            <div className={cx('collapse_row_recipe')}>
              {/* <Col xs={24}> */}
              <Collapse
                defaultActiveKey={['1']}
                activeKey={activeCollapseKey}
                expandIconPosition={'end'}
              >
                <Panel header={FormHeader()} key="1">
                  {/* <Row gutter={24}> */}
                  {/* <Col xs={24} lg={12}> */}
                  <Form
                    className={styles.form}
                    form={form}
                    onValuesChange={(values) => setFormValues(values)}
                    name="explore"
                    initialValues={{
                      threat_name: exploreRecipeHostingInfraIPs?.domain,
                      type: exploreRecipeHostingInfraIPs?.query_type,
                      first_seen_before: exploreRecipeHostingInfraIPs?.first_seen_before
                        ? moment(
                            exploreRecipeHostingInfraIPs?.first_seen_before,
                          )
                        : '',
                      first_seen_after: exploreRecipeHostingInfraIPs?.first_seen_after
                        ? moment(exploreRecipeHostingInfraIPs?.first_seen_after)
                        : '',
                      last_seen_before: exploreRecipeHostingInfraIPs?.last_seen_before
                        ? moment(exploreRecipeHostingInfraIPs?.last_seen_before)
                        : '',
                      last_seen_after: exploreRecipeHostingInfraIPs?.last_seen_after
                        ? moment(exploreRecipeHostingInfraIPs?.last_seen_after)
                        : '',
                      limit:
                        exploreRecipeHostingInfraIPs?.limit === 100
                          ? ''
                          : exploreRecipeHostingInfraIPs?.limit,
                      sort: exploreRecipeHostingInfraIPs?.sort_by
                        ? [
                            exploreRecipeHostingInfraIPs?.sort_by,
                            exploreRecipeHostingInfraIPs?.order_by,
                          ]
                        : null,
                      subdomains: exploreRecipeHostingInfraIPs?.include_subdomains
                        ? 'true'
                        : 'false',
                      is_last_24_hours: exploreRecipeHostingInfraIPs?.is_last_24_hours
                        ? exploreRecipeHostingInfraIPs?.is_last_24_hours
                        : false,
                    }}
                    onFinish={(values) => {
                      props.saveBreadCrumbs(null);

                      // props.history.push(
                      setSearchQuery(
                        `/explore-result?name=${(values.subdomains === 'true'
                          ? '*.' + values.threat_name
                          : values.threat_name
                        )
                          .replace('[', '')
                          .replace(']', '')
                          .replace(' ', '')
                          .trim()}&queryType=query&type=` +
                          (values.type ? values.type : 'A') +
                          (is24hrCheckboxSetCurrentValue === true
                            ? `&first_seen_after=-86400`
                            : (values.first_seen_before
                                ? `&first_seen_before=${moment(
                                    values.first_seen_before,
                                  )
                                    .utc({ keepLocalTime: false })
                                    .set('hour', 0)
                                    .set('minute', 0)
                                    .set('second', 0)
                                    .set('millisecond', 0)
                                    .format('YYYY-MM-DD')}`
                                : '') +
                              (values.first_seen_after
                                ? `&first_seen_after=${moment(
                                    values.first_seen_after,
                                  )
                                    .utc({ keepLocalTime: false })
                                    .set('hour', 0)
                                    .set('minute', 0)
                                    .set('second', 0)
                                    .set('millisecond', 0)
                                    .format('YYYY-MM-DD')}`
                                : '') +
                              (values.last_seen_before
                                ? `&last_seen_before=${moment(
                                    values.last_seen_before,
                                  )
                                    .utc({ keepLocalTime: false })
                                    .set('hour', 0)
                                    .set('minute', 0)
                                    .set('second', 0)
                                    .set('millisecond', 0)
                                    .format('YYYY-MM-DD')}`
                                : '') +
                              (values.last_seen_after
                                ? `&last_seen_after=${moment(
                                    values.last_seen_after,
                                  )
                                    .utc({ keepLocalTime: false })
                                    .set('hour', 0)
                                    .set('minute', 0)
                                    .set('second', 0)
                                    .set('millisecond', 0)
                                    .format('YYYY-MM-DD')}`
                                : '')) +
                          (values.limit ? `&limit=${values.limit}` : '') +
                          (values?.sort?.length > 0
                            ? `&sort_by=${values?.sort[0]}&order_by=${values?.sort[1]}`
                            : '') +
                          '&origin_uid=HOSTING_INFRA_IPS&recipe=/explore/hosting-infra-ips' +
                          ((q?.get('recipeid')
                            ? `?recipeid=${q?.get('recipeid')}`
                            : '') ?? '') +
                          '&backLink=' +
                          encodeURIComponent(window.location.pathname) +
                          encodeURIComponent(window.location.search),
                      );
                      searchActionCollapse();
                      setTimeout(() => {
                        window.scrollTo(0, 0);
                      }, '10');
                    }}
                  >
                    <Row gutter={36}>
                      <Col xs={24}>
                        <Title
                          data-cy="hostingInfrastructureIPsRecipeQueryFormAnswerTypeLabel"
                          level={5}
                        >
                          Answer Type{' '}
                          <Tooltip
                            placement="top"
                            title="Select the type of output records (optional)."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Title>

                        <Text data-cy="hostingInfrastructureIPsRecipeQueryFormAnswerTypeTextLabel">
                          Output Record Type
                        </Text>
                        <Form.Item
                          name="type"
                          rules={[
                            {
                              required: false,
                              message: 'Please input the type!',
                            },
                          ]}
                        >
                          <Radio.Group
                            data-cy="hostingInfrastructureIPsRecipeQueryFormAnswerTypeSelector"
                            options={[
                              { label: 'A', value: 'A' },
                              { label: 'AAAA', value: 'AAAA' },
                            ]}
                            defaultValue="A"
                            optionType="button"
                            buttonStyle="solid"
                            style={{ background: 'none' }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24}>
                        <Title
                          data-cy="hostingInfrastructureIPsRecipeQueryFormDomainLabel"
                          level={5}
                        >
                          Domain *
                        </Title>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Text data-cy="hostingInfrastructureIPsRecipeQueryFormDomainNameLabel">
                          Domain Name{' '}
                          <Tooltip
                            placement="top"
                            title="Enter a domain name. Subdomains are included in the search. Wildcards are not supported."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Text>
                        <Form.Item
                          name="threat_name"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(fieldObject, fieldValue) {
                                const validation = validateRecipeDomainName(
                                  fieldValue,
                                  titleText,
                                );

                                if (validation.valid) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject(validation?.message);
                                }
                              },
                            }),
                          ]}
                        >
                          <Input
                            data-cy="hostingInfrastructureIPsRecipeQueryFormDomainInput"
                            maxLength={255}
                            placeholder="Enter Domain Name"
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Text data-cy="hostingInfrastructureIPsRecipeQueryFormSubdomainsLabel">
                          Subdomains{' '}
                          <Tooltip
                            placement="top"
                            title="Include subdomains in the search result (optional)."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Text>

                        <Form.Item
                          name="subdomains"
                          rules={[
                            {
                              required: false,
                              message:
                                'Please select if subdomains should be included!',
                            },
                          ]}
                        >
                          <Select
                            data-cy="hostingInfrastructureIPsRecipeQueryFormSubdomainsSelect"
                            options={[
                              { label: 'Exclude', value: 'false' },
                              { label: 'Include', value: 'true' },
                            ]}
                            defaultValue="false"
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24}>
                        <Title
                          data-cy="hostingInfrastructureIPsRecipeQueryFormFirstSeenLabel"
                          level={5}
                        >
                          First Seen{' '}
                          <Tooltip
                            placement="top"
                            title="Set the time frame when the A record(s) was first seen (optional)."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Title>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Text data-cy="hostingInfrastructureIPsRecipeQueryFormFirstSeenAfterLabel">
                          First Seen After
                        </Text>
                        <Form.Item
                          name="first_seen_after"
                          rules={[
                            {
                              required: false,
                              message: 'Please input the netmask!',
                            },
                          ]}
                        >
                          <DatePicker
                            data-cy="hostingInfrastructureIPsRecipeQueryFormFirstSeenAfterDatePicker"
                            inputReadOnly={true}
                            placeholder="First Seen After"
                          ></DatePicker>
                        </Form.Item>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Text data-cy="hostingInfrastructureIPsRecipeQueryFormFirstSeenBeforeLabel">
                          First Seen Before
                        </Text>
                        <Form.Item
                          name="first_seen_before"
                          rules={[
                            {
                              required: false,
                              message: 'Please input the first seen!',
                            },
                          ]}
                        >
                          <DatePicker
                            data-cy="hostingInfrastructureIPsRecipeQueryFormFirstSeenBeforeDatePicker"
                            inputReadOnly={true}
                            placeholder="First Seen Before"
                          ></DatePicker>
                        </Form.Item>
                      </Col>

                      <Col xs={24}>
                        <Title
                          data-cy="hostingInfrastructureIPsRecipeQueryFormLastSeenLabel"
                          level={5}
                        >
                          Last Seen{' '}
                          <Tooltip
                            placement="top"
                            title="Set the time frame when the A record(s) was last seen (optional)."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Title>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Text data-cy="hostingInfrastructureIPsRecipeQueryFormLastSeenAfterLabel">
                          Last Seen After
                        </Text>
                        <Form.Item
                          name="last_seen_after"
                          rules={[
                            {
                              required: false,
                              message: 'Please input the netmask!',
                            },
                          ]}
                        >
                          <DatePicker
                            data-cy="hostingInfrastructureIPsRecipeQueryFormLastSeenDatePicker"
                            inputReadOnly={true}
                            placeholder="Last Seen After"
                          ></DatePicker>
                        </Form.Item>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Text data-cy="hostingInfrastructureIPsRecipeQueryFormLastSeenBeforeLabel">
                          Last Seen Before
                        </Text>
                        <Form.Item
                          name="last_seen_before"
                          rules={[
                            {
                              required: false,
                              message: 'Please input the netmask!',
                            },
                          ]}
                        >
                          <DatePicker
                            data-cy="hostingInfrastructureIPsRecipeQueryFormLastSeenBeforeDatePicker"
                            inputReadOnly={true}
                            placeholder="Last Seen Before"
                          ></DatePicker>
                        </Form.Item>
                      </Col>

                      <Col xs={24}>
                        <Title
                          data-cy="hostingInfrastructureIPsRecipeQueryFormSortingLabel"
                          level={5}
                        >
                          Sorting
                        </Title>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Text data-cy="hostingInfrastructureIPsRecipeQueryFormSortOrderLabel">
                          Sort/Order
                        </Text>
                        <Form.Item name="sort">
                          <Cascader
                            data-cy="hostingInfrastructureIPsRecipeQueryFormSortingSelector"
                            options={options}
                            placeholder="Sort/Order"
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Text data-cy="hostingInfrastructureIPsRecipeQueryFormLast24HoursLabel">
                          Last 24 hours{' '}
                          <Tooltip
                            placement="top"
                            title="Only show records first observed in the last 24 hours (optional)."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Text>

                        <Form.Item
                          name="is_last_24_hours"
                          valuePropName="checked"
                          rules={[
                            {
                              required: false,
                              message: 'Please select the last 24 hours!',
                            },
                          ]}
                        >
                          <Checkbox
                            data-cy="hostingInfrastructureIPsRecipeQueryFormLast24HoursCheckbox"
                            onChange={() =>
                              setIs24hrCheckboxSet(
                                (is24hrCheckboxSet) => !is24hrCheckboxSet,
                              )
                            }
                          >
                            Last 24 hours
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={36}>
                      <Col xs={24}>
                        <div className={styles.bottom_actions}>
                          <Form.Item>
                            <Tooltip
                              title={
                                props.mySubscriptionPlan
                                  ?.has_access_to_explore ? (
                                  ''
                                ) : (
                                  <>
                                    This option is not part of this subscription
                                    plan. To upgrade your subscription contact
                                    us at{' '}
                                    <a
                                      target="_blank"
                                      href="mailto:sales@silentpush.com"
                                    >
                                      sales@silentpush.com
                                    </a>
                                    .
                                  </>
                                )
                              }
                            >
                              <Button
                                disabled={
                                  !props.mySubscriptionPlan
                                    ?.has_access_to_explore
                                }
                                role={'button2'}
                                type="primary"
                                htmlType="submit"
                              >
                                Search
                              </Button>
                            </Tooltip>
                          </Form.Item>

                          <Button
                            className="ms-05"
                            type="link"
                            onClick={() => resetForm()}
                          >
                            Reset
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Panel>
              </Collapse>
              {/* </Col> */}
            </div>
            <div className={cx('collapse_row_recipe')}>
              {/* <Col xs={24}> */}
              <Collapse
                defaultActiveKey={['2']}
                activeKey={activeCollapseKey}
                expandIconPosition={'end'}
              >
                <Panel header={ResultsHeader()} key="2">
                  {/* <Row gutter={24}> */}
                  {/* <Col xs={24} lg={12}> */}
                  <div>
                    {searchQuery ? (
                      <HostingInfrastructureIPsResult
                        searchQuery={searchQuery}
                        mySubscriptionPlanStatus={
                          props.mySubscriptionPlanStatus
                        }
                        mySubscriptionPlan={props.mySubscriptionPlan}
                        loadMergeAPIRiskScores={loadMergeAPIRiskScores}
                        loadMergeAPIASNDetails={loadMergeAPIASNDetails}
                        loadUser={loadUser}
                        loadSources={loadSources}
                        createEmptySource={createEmptySource}
                        createFileSource={createFileSource}
                        updateFileSource={updateFileSource}
                        addIOCJson={addIOCJson}
                        clearExploreDetails={clearExploreDetails}
                        loadScoreDetails={loadScoreDetails}
                        loadMergeAPIExploreRecipe={loadMergeAPIExploreRecipe}
                        loadMergeAPIEnrichment={loadMergeAPIEnrichment}
                        loadMergeAPIIPDetails={loadMergeAPIIPDetails}
                        loadMergeAPIDomainDetails={loadMergeAPIDomainDetails}
                        loadMergeAPIExploreDetails={loadMergeAPIExploreDetails}
                        loadMergeAPIMergeDetails={loadMergeAPIMergeDetails}
                        loadMergeAPIExploreAnyIPDetails={
                          loadMergeAPIExploreAnyIPDetails
                        }
                        loadMergeAPIExploreDensity={loadMergeAPIExploreDensity}
                        loadMergeAPIWhoisDetails={loadMergeAPIWhoisDetails}
                        loadMergeAPIDomainInfraTags={
                          loadMergeAPIDomainInfraTags
                        }
                        loadIPEditableFeeds={loadIPEditableFeeds}
                        loadDomainEditableFeeds={loadDomainEditableFeeds}
                        loadURLEditableFeeds={loadURLEditableFeeds}
                        searchForTags={searchForTags}
                        resetTagSearch={resetTagSearch}
                        saveMonitoringQuery={saveMonitoringQuery}
                        loadResultFile={loadResultFile}
                        loadHistoryQueryResult={loadHistoryQueryResult}
                        exportExploreResultToCSV={exportExploreResultToCSV}
                        exportExploreResultToJSON={exportExploreResultToJSON}
                        exportDanglingDNSToCSV={exportDanglingDNSToCSV}
                        exportDanglingDNSToJSON={exportDanglingDNSToJSON}
                        exportSingleIOC={exportSingleIOC}
                        resetEnrichment={resetEnrichment}
                        loadMySubscriptionPlan={loadMySubscriptionPlan}
                        saveBreadCrumbs={saveBreadCrumbs}
                        queryNameInTXTRecipe={queryNameInTXTRecipe}
                        user={user}
                        //sources
                        exploreFilters={exploreFilters}
                        exploreSorting={exploreSorting}
                        status={status}
                        scoreDetails={scoreDetails}
                        mergeAPIEnrichment={mergeAPIEnrichment}
                        mergeAPIscoreDetails={mergeAPIscoreDetails}
                        exploreAPIscoreDetails={exploreAPIscoreDetails}
                        mergeAPIData={mergeAPIData}
                        exploreAPIANYIPscoreDetails={
                          exploreAPIANYIPscoreDetails
                        }
                        exploreAPIANYIPJobID={exploreAPIANYIPJobID}
                        exploreAPIDensityDetails={exploreAPIDensityDetails}
                        exploreAPIDensityStatus={exploreAPIDensityStatus}
                        exploreAPIwhoisDetails={exploreAPIwhoisDetails}
                        infraTagStatus={infraTagStatus}
                        domainInfraTags={domainInfraTags}
                        whoisStatus={whoisStatus}
                        IPEditableFeeds={IPEditableFeeds}
                        IPEditableFeedsStatus={IPEditableFeedsStatus}
                        DomainEditableFeeds={DomainEditableFeeds}
                        DomainEditableFeedsStatus={DomainEditableFeedsStatus}
                        URLEditableFeeds={URLEditableFeeds}
                        URLEditableFeedsStatus={URLEditableFeedsStatus}
                        foundTags={foundTags}
                        searchStatus={searchStatus}
                        riskScoreStatus={riskScoreStatus}
                        exploreRiskScores={exploreRiskScores}
                        exploreASNStatus={exploreASNStatus}
                        exploreASNDetails={exploreASNDetails}
                        breadcrumbs={breadcrumbs}
                        loadBrandImpersonationRecipeResults={
                          loadBrandImpersonationRecipeResults
                        }
                        loadDanglingDNSDetectionRecipeResults={
                          loadDanglingDNSDetectionRecipeResults
                        }
                        loadHostingInfrastructureIPsRecipeResults={
                          loadHostingInfrastructureIPsRecipeResults
                        }
                        websocketConnection={props?.websocketConnection}
                      />
                    ) : (
                      <div className={styles.empty_state}>
                        <NoDataIcon
                          style={{ fontSize: 32, marginTop: '8px' }}
                        />
                        <Title level={4}>Query didn't run</Title>

                        <Text>
                          For the results you need to fill out the query form
                          and click Search.
                        </Text>
                      </div>
                    )}
                  </div>
                  {/* </Col> */}
                  {/* </Row> */}
                </Panel>
              </Collapse>
              {/* </Col> */}
            </div>
          </div>
        ) : (
          <LoadingSilentPush size={80} positionCenter />
        )
      ) : (
        <PermissionDeniedPage />
      )
    ) : (
      <LoadingSilentPush size={80} positionCenter />
    );
  }

  return (
    <>
      <SavedRecipeModal
        isModalVisible={isModalVisible}
        isSaveModalValid={isSaveModalValid}
        handleOk={handleOk}
        handleCancel={handleCancel}
        nameOfNewQuery={nameOfNewQuery}
        setNameOfNewQuery={setNameOfNewQuery}
        descriptionOfNewQuery={descriptionOfNewQuery}
        setDescriptionOfNewQuery={setDescriptionOfNewQuery}
        type={saveModalType}
        loadedRecipe={exploreRecipeHostingInfraIPs}
      />
      <DeleteRecipeModal
        isDeleteModalVisible={isDeleteModalVisible}
        handleOk={handleDeleteRecipe}
        handleCancel={handleDeleteCancel}
        loadedRecipe={exploreRecipeHostingInfraIPs}
      />
      {renderPane()}
      <VersionCheck
        parentComponentStatus={
          q?.get('recipeid') ? props.recipeStatusHostingInfraIPs : STATUS.LOADED
        }
      />
    </>
  );
}

export default HostingInfrastructureIPsQuery;
